import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isEmpty } from 'lodash-es';
import { CmsEntities } from 'client/data/models/cms';
import { LT_8_CLASS } from 'site-modules/shared/constants/top-rated/top-rated';
import { FilmstripCarousel } from 'site-modules/shared/components/core-page/sponsored-cars/filmstrip-carousel/filmstrip-carousel';

import { NavAnchor } from './nav-anchor';

export function CategoryTopNav({ categoryTilesEntries = null, tileNumClass = null, year = null, isMobile = false }) {
  const isOddNumLength = categoryTilesEntries.length % 2 === 1;

  const renderCategoryTilesEntries = categoryTilesEntries.map(
    (entry, index) =>
      entry && (
        <NavAnchor
          key={`nav-${year}-${index + 1}`}
          entry={entry}
          index={index}
          isOddNumLength={isOddNumLength}
          tileNumClass={tileNumClass}
          isMobile={isMobile}
          year={year}
        />
      )
  );

  return (
    <nav
      aria-label="top rated winners"
      className={classnames(
        `nav-category-tiles pos-r text-center mx-lg-auto px-0_75 nav-count-${categoryTilesEntries.length}`,
        {
          'text-lg-start': tileNumClass === LT_8_CLASS,
        }
      )}
      data-tracking-parent="edm-entry-top-rated-carousel"
    >
      {tileNumClass === LT_8_CLASS || isMobile ? (
        renderCategoryTilesEntries
      ) : (
        <FilmstripCarousel
          totalAdCount={!isEmpty(categoryTilesEntries) ? categoryTilesEntries.length : 0}
          scrollByParentWidth
        >
          {renderCategoryTilesEntries}
        </FilmstripCarousel>
      )}
    </nav>
  );
}

CategoryTopNav.propTypes = {
  categoryTilesEntries: PropTypes.arrayOf(CmsEntities.Content),
  tileNumClass: PropTypes.string,
  year: PropTypes.string,
  isMobile: PropTypes.bool,
};
